import { WEB_SERVICES } from '../../../../bitSagas/webServices';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        UNAVAILABLE_PRODUCT: errorToPrint.UNAVAILABLE_PRODUCT,
        ALREADY_HIRED_EQUIPMENT: errorToPrint.ALREADY_HIRED_EQUIPMENT,
        DECODER_AVAILABLE: errorToPrint.DECODER_AVAILABLE,
        UNAVAILABLE_OR_ALREADY_HIRED: errorToPrint.UNAVAILABLE_OR_ALREADY_HIRED,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.UNAVAILABLE_PRODUCT,
          [WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER]: errorToPrint.UNAVAILABLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.ALREADY_HIRED_EQUIPMENT,
          [WEBSERVICE_ERRORS.OFFER_WITH_SOME_DEPENDENCIES]: errorToPrint.UNAVAILABLE_PRODUCT,
          [WEBSERVICE_ERRORS.PRODUCT_REGISTERED]: errorToPrint.ALREADY_HIRED_EQUIPMENT,
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_2]: errorToPrint.ALREADY_HIRED_EQUIPMENT,
        },
        [WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING]: {
          [WEBSERVICE_ERRORS.NO_HIRED_PRODUCTS_TO_BUY]: errorToPrint.UNAVAILABLE_PRODUCT,
        },
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.ROUTER_WIFI_6_NEEDED]: errorToPrint.ROUTER_WIFI_6_NEEDED,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
